import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtWindowService {
  onbeforeunload = window.onbeforeunload;

  reload() {
    location.reload();
  }

  setTimeout(func: () => void, timeOut): number {
    return window.setTimeout(func, timeOut);
  }
}
